import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border h-72 w-full overflow-auto relative" }
const _hoisted_2 = ["innerHTML"]

import { computed, ref } from 'vue';
import { BaseButton } from '@/lib/components/Button';
import useClipboard from 'vue-clipboard3';


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyableTextSummary',
  props: {
  context: {
    type: String,
    default: ''
  },
  copyEnable: {
    type: Boolean,
    default: true
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ["success", "error"],
  setup(__props, { emit }: { emit: ({
  (e: 'success'): void;
  (e: 'error'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const container = ref(null);
const formatContext = computed(() => props.context.replace(/&lt;/g, '<').replace(/&gt;/g, '>'));

const copyToClipboard = async () => {
  try {
    const temp = formatContext.value;
    const titleRegex = /<\/*b\s*[/]?>/gi;
    const newLineRegex = /<br\s*[/]?>/gi;
    const afterNewLine = temp.replace(newLineRegex, '\r\n');
    const afterTitle = afterNewLine.replace(titleRegex, '\r\n');
    const { toClipboard } = useClipboard();
    await toClipboard(afterTitle, container.value);
    emit('success');
  } catch (error) {
    emit('error');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseButton), {
      style: {"position":"sticky","top":"0"},
      class: "mt-4 mr-4 float-right",
      disabled: __props.loading,
      onClick: copyToClipboard
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Copy to Clipboard ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    (__props.copyEnable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "container",
          ref: container,
          class: "ml-8 mb-8",
          innerHTML: _unref(formatContext)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})